<template>
    <div>
        
    </div>
</template>
    
<script>
import {mapGetters,mapState} from 'vuex';

export default {
    data: () => ({
        mainNode: null,
        videos: ["./flux/Trommel4_1.mp4","./flux/Trommel4_2.mp4"],

        currentVideoIndex: 0,
        videoTextures: [],
        videoMaterial: null,
    }),
    computed: {
        ...mapGetters(['currentSituationID','followModeratorMode','sendingFollowModerator','localUserID']),
        ...mapState({session: (state) => state.session.openTokSession}), 
	},
    watch: {
        currentSituationID(){
            this.mainNode.setEnabled(this.currentSituationID == 260705)    
        },
        session: function(){
            if(this.session){
                this.session.on("signal:playImageSphereAnimation", (event) => {
                    let data = event.data.split(",");
                    let userID = data[0];
                    if(userID == this.localUserID)
                        return;

                    this.toggleVideo();
                });
            }
        },
    },
	methods: {
        initializeElement(){
            this.mainNode = new BABYLON.TransformNode("ImageSphereAnimation",window.scene); 

            let sphere = BABYLON.MeshBuilder.CreateSphere("Sphere", {arc: 0.25,diameterX: 398, diameterY: 398, diameterZ: 398});
            sphere.scaling.y = -1;
            sphere.rotation.y = 2.35619;
            sphere.parent = this.mainNode;

            this.videos.forEach(videoURL => {
                let videoTexture = new BABYLON.VideoTexture("", videoURL, window.scene, false, false, BABYLON.TRILINEAR_SAMPLINGMODE, { 
                    autoPlay: false,
                    autoUpdateTexture: true,
                    muted: true,
                    preload: "metadata"
                })
                videoTexture.video.preload = "metadata";

                let video = videoTexture.video;
                video.currentTime = 0.72;
                if(video.paused){
                    video.play().then( ()=>{
                        video.pause();
                    });
                }

                this.videoTextures.push(videoTexture);
            });

            this.videoMaterial = new BABYLON.StandardMaterial("videoMaterial", window.scene);
            this.videoMaterial.diffuseTexture = this.videoTextures[0]; 
            this.videoMaterial.emissiveColor = BABYLON.Color3.White();
            this.videoMaterial.opacityTexture = new BABYLON.Texture("./flux/Alpha.png", window.scene); 
            this.videoMaterial.disableLighting = true;   
            this.videoMaterial.backFaceCulling = false;
            sphere.material = this.videoMaterial;

            let button = BABYLON.MeshBuilder.CreatePlane("Button",{width: 10,height: 10,sideOrientation: BABYLON.Mesh.DOUBLESIDE},window.scene);
            button.position = new BABYLON.Vector3(-90,-26,2);
            button.rotation.y = Math.PI * 3/2;
            button.parent = this.mainNode;
            button.material = new BABYLON.StandardMaterial("", window.scene);
            button.material.emissiveColor  = new BABYLON.Color3.White();
            button.material.disableLighting = true;
            button.material.emissiveTexture  = button.material.diffuseTexture =  button.material.opacityTexture = new BABYLON.Texture("./flux/change.png", window.scene);
            
            button.actionManager = new BABYLON.ActionManager(window.scene);
            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, ()=>{ 
                if(this.canUserControllVideo()){
                    this.toggleVideo();
                    this.sendModeratorCommand();
                }
            }));

            // button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function(){     
            //     BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,7, button.scaling, new BABYLON.Vector3.One(), 0, ease);
            // }));

            // button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function(){
            //     BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,7, new BABYLON.Vector3.One(), new BABYLON.Vector3.One().scale(1.2), 0,ease);
            // }));
            
        },
        sendModeratorCommand(){
            if(this.session && this.sendingFollowModerator){
                const signalData = {
                    type: "playImageSphereAnimation", 
                    data: this.localUserID,
                };
                this.session.signal(signalData, function (error) {
                    if(error) console.log(['signal error (', error.code, '): ', error.message].join(''));
                    else console.log('playImageSphereAnimation signal sent');   
                });
            }
        },
        toggleVideo(){
            let video1 = this.videoTextures[this.currentVideoIndex].video;    
            video1.currentTime = video1.duration/2;
            
            this.currentVideoIndex = this.currentVideoIndex == 0 ? 1 : 0;

            let video2 = this.videoTextures[this.currentVideoIndex].video;
            video2.currentTime = 0;   
            
            let id1 = setInterval(() => {
                if(video1.currentTime >= video1.duration){
                    clearInterval(id1);

                    video1.pause();
                    this.videoMaterial.diffuseTexture = this.videoTextures[this.currentVideoIndex]; 
                    video2.play();

                    let id2 = setInterval(() => {
                            if(video2.currentTime >= video2.duration/2){
                            clearInterval(id2);

                            video2.pause();
                        }
                    }, 1);
                    
                }
            }, 1);
            video1.play();
        },
        canUserControllVideo(){
            return !this.followModeratorMode || this.sendingFollowModerator;
        }
    },
    mounted(){
        setTimeout(() => {
            this.initializeElement();
        }, 1000);
    }
}
</script>


<style>
    
</style>